import { HighlightSectionHeader } from './highlight-section-header';
import { HighlightSectionSkeletonCards } from './highlight-section-skeleton-cards';

export const HighlightSectionSkeletonContent = ({
  title,
  subtitle,
  cardCount = 6,
}: {
  title: string;
  subtitle?: string;
  cardCount?: number;
}) => (
  <>
    <HighlightSectionHeader title={title} subtitle={subtitle} isLoading />
    <div className='max-w-full overflow-x-auto scrollbar-hide gap-4 px-4 pb-0 flex md:grid md:grid-cols-12'>
      <HighlightSectionSkeletonCards cardCount={cardCount} />
    </div>
  </>
);
